import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Observable, ReplaySubject} from 'rxjs';
import {Model} from '../../../../../domain/model/common/model.class';
import {AbpsBoardService} from '../../../../../domain/model/licenses-certifications/board/abps/abps-board.service';
import {ActivatedRoute} from '@angular/router';
import {FormErrors} from '../../../../../components/forms/validation/form-validator.class';
import {AbpsBoard} from '../../../../../domain/model/licenses-certifications/board/abps/abps-board.model';
import {StepScreenModel} from '../../../../shared/step/step-screen.component';
import {FileLocation, FileLocationFactory} from '../../../../../components/files/service/file-location.class';
import {AbpsBoardScreensManager} from './abps-board-screens-manager.service';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;
import { VerificationService } from '../../../../../components/verification/service/verification.service';

@Component({
    template: require('./abps-board-screen.component.html')
})
export class AbpsBoardScreenComponent {

    constructor(readonly modelService: AbpsBoardService,
                readonly route: ActivatedRoute,
                readonly screensManager: AbpsBoardScreensManager,
                readonly fileLocationFactory: FileLocationFactory,
                readonly verificationService: VerificationService) {
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    certifications: Array<string> = [
        'American Association of Administrative Medicine',
        'American Association of Anesthesiology',
        'American Association of Dermatology',
        'American Association of Diagnostic Radiology',
        'American Association of Disaster Medicine',
        'American Association of Emergency Medicine',
        'American Association of Family Medicine',
        'American Association of Family Medicine Obstetrics',
        'American Association of Geriatric Medicine',
        'American Association of Hospital Medicine',
        'American Association of Integrative Medicine',
        'American Association of Internal Medicine',
        'American Association of Obstetrics and Gynecology',
        'American Association of Opthalmology',
        'American Association of Othopaedic Surgery',
        'American Association of Plastic and Reconstructive Surgery',
        'American Association of Psychiatry',
        'American Association of Radiation Oncology',
        'American Association of Radiology',
        'American Association of Surgery',
        'American Association of Urgent Care Medicine'
    ];

    certificationDateConstrains = {
        min: moment().subtract(100, 'year'),
        max: moment().add(5, 'year')
    };
    supportingDocumentFileLocation: FileLocation;

    get index(): number {
        return +this.route.snapshot.params['index'];
    }

    stepScreenModel = new StepScreenModel<AbpsBoard>({
        initialDataModel: new AbpsBoard(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            this.supportingDocumentFileLocation = this.fileLocationFactory.create('abpsBoard', `currentUser/${this.index}`, new ProjectionInformation('supportingDocument'));
            this.verificationService.setUrl('abpsBoard', undefined, `${this.index}`);
            return this.modelService.getCurrentUserModelEntry(this.index);
        },
        _submitDataFn: (model: AbpsBoard) => {
            return this.modelService.updateCurrentUserModelEntry(this.index, model);
        },
        _hasYesNoQuestion: () => this.index !== 1 ? this.modelService.doesCurrentUserModelEntryExist(this.index).map(r => !r) : Observable.of(false)
    });

    get model(): AbpsBoard {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleCurrentlyCertifiedChange() {
        if (!this.model.currentlyCertified) this.model.certificationDate = undefined;
    }

    handleRecertifiedChange() {
        if (!this.model.recertified) this.model.recertificationDate = undefined;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/board/abps/abps-board-screen.component.ts